<template>
  <div class="process-progress-bar">
    <div
      v-for="(option, index) in options"
      :key="option"
      :class="{
        'process-progress-bar__item': true,
        'process-progress-bar__item--active': index <= currentItemIndex,
        'process-progress-bar__item--complete':
          index < currentItemIndex || currentItemIndex === options.length - 1
      }"
    >
      <div class="process-progress-bar__number">{{ index + 1 }}</div>
      <div class="process-progress-bar__text">{{ option }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VProcessProgress",
  model: {
    prop: "currentItemIndex"
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    currentItemIndex: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/variables";
.process-progress-bar {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  &__item {
    text-align: center;
    width: 19%;
    position: relative;
    &:not(:last-child) {
      &::after {
        position: absolute;
        left: calc(50% + 24px);
        width: 58%;
        height: 2px;
        background: $color-medium-grey;
        content: "";
        top: 17px;
      }
    }

    &--active {
      .process-progress-bar {
        &__number {
          color: #fff;
          border-color: #004593;
          background-color: #004593;
        }
        &__text {
          color: #004593;
        }
      }
    }
    &--complete {
      .process-progress-bar {
        &__number {
          text-indent: -999999px;
          background-image: url("~@/assets/icons/icon-progress-check.svg");
        }
      }
      &::after {
        background: $color-primary !important;
      }
    }
  }
  &__number {
    width: 32px;
    height: 32px;
    color: $color-medium-grey;
    background-color: #fff;
    border: 2px solid $color-medium-grey;
    border-radius: 50%;
    text-align: center;
    line-height: 28px;
    font-size: 16px;
    display: inline-block;
    overflow: hidden;
    background-position: center;
    background-repeat: no-repeat;
  }
  &__text {
    font-size: 13px;
    margin: 11px auto;
    color: $color-medium-grey;
    max-width: 105px;
  }
}
</style>
